import React, {
  ReactElement, useRef, useState
} from 'react'
import { Menu } from '@mui/material'
interface Props {
  button: ReactElement
  children: ReactElement | ReactElement[]
}
const ButtonMenu:ReactFC<Props> = ({ button, children }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const refEl = useRef<HTMLElement>()

  const cloneElement = (el:ReactElement) =>
    React.cloneElement(
      el,
      {
        ...el.props,
        onClick: () => {
          el.props.onClick?.()
          setMenuOpen(false)
        }
      }
    )

  return (
    <>
      {React.cloneElement(button, {
        ...button.props,
        onClick: () => {
          setMenuOpen(true)
          button.props.onClick?.()
        },
        ref: refEl
      })}
      <Menu
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        anchorEl={refEl.current}
      >
        {Array.isArray(children)
          ? React.Children.map(children, (el:ReactElement) => (cloneElement(el)))
          : cloneElement(children)
        }
      </Menu>
    </>
  )
}
export default ButtonMenu
